
// Get param from url.
export function getParam(key: 'model' | 'style' | 'code' | 'admin'): string {
    const urlParams = new URLSearchParams(window.location.search);
    try {
        let result = urlParams.get(key)
        if (key === 'model') result = result.toLocaleLowerCase()
        return result
    }
    catch { }
}
